<div class="container review-layout">
  <div class="row">
    <div class="col-sm-10 offset-sm-1 mw-100" *ngIf="!displayThanks && !displayUsedLink">
      <div class="bordered-container">
        <spinner *ngIf="loading" spinnerType="inner-circles-loader"></spinner>
        <div class="alert alert-danger alert-dismissible" *ngIf="isError">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <span *ngIf="errMsg">{{errMsg}}</span>
          <span *ngIf="!errMsg">We are sorry, error happened on the server. Please contact us at <a target="_blank" href="mailto:support@purchaseclinic.com">support@purchaseclinic.com</a>.</span>
        </div>
        <section [hidden]="loading">
          <div class="bordered-content clearfix animated slideInRight faster" style="min-height: 200px" [hidden]="step!==0">
            <div class="row">
              <div class="col-12">
                <p>Thank you for signing up for {{themeName}}.</p>
                <p>Please edit any information as necessary and then click “Continue” so we can optimize your account.</p>
              </div>
            </div>
            <div class="card mb-3">
              <div class="card-body">
                <div class="row">
                  <div class="col-6"><span class="align-middle">Contact information:</span></div>
                  <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-info float-right" (click)="toggleDetailsEdit()"><i class="fas fa-pen-square"></i>&nbsp;&nbsp;Edit</button>
                  </div>
                </div>
                <section *ngIf="!detailsEdit">
                  <div class="row">
                    <div class="col-12">
                      <div>{{signup.user.fname}} {{signup.user.lname}}</div>
                      <div>{{signup.user.email}}</div>
                      <div>{{signup.location.facility_name}}</div>
                      <div>{{signup.location.address}}</div>
                      <div *ngIf="signup.location.address2">{{signup.location.address2}}</div>
                      <div>{{[signup.location.city, signup.location.state, signup.location.zip]|arr_join}}</div>
                    </div>
                  </div>
                </section>
                <section *ngIf="detailsEdit">
                  <div class="row pc2-form-group pc2-row-pad">
                    <div class="col-6"><input class="form-control" [(ngModel)]="signup.user.fname" placeholder="First Name" type="text"/></div>
                    <div class="col-6"><input class="form-control" [(ngModel)]="signup.user.lname" placeholder="Last Name" type="text"/></div>
                  </div>
                  <div class="row pc2-form-group">
                    <div class="col-sm-6">
                      <input class="form-control" [(ngModel)]="signup.user.email" placeholder="Email" type="email"/>
                    </div>
                    <div class="col-sm-6">
                      <input class="form-control" [(ngModel)]="signup.user.phone" placeholder="Phone" type="text"/>
                    </div>
                  </div>
                  <div class="row pc2-form-group">
                    <div class="col-12">
                      <input class="form-control" [(ngModel)]="signup.user.job_title" placeholder="Job Title" type="text"/>
                    </div>
                  </div>
                  <div class="row pc2-form-group">
                    <div class="col-12">
                      <input class="form-control" [(ngModel)]="signup.location.facility_name" placeholder="Company Name" type="text"/>
                    </div>
                  </div>
                  <div class="row pc2-form-group">
                    <div class="col-12">
                      <input class="form-control" [(ngModel)]="signup.location.address" placeholder="Address" type="text"/>
                    </div>
                  </div>
                  <div class="row pc2-form-group">
                    <div class="col-12">
                      <input class="form-control" [(ngModel)]="signup.location.address2" placeholder="Address 2" type="text"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4"><input class="form-control" [(ngModel)]="signup.location.city" placeholder="City" type="text"/></div>
                    <div class="col-sm-4"><input class="form-control" [(ngModel)]="signup.location.state" placeholder="State" type="text"/></div>
                    <div class="col-sm-4"><input class="form-control" [(ngModel)]="signup.location.zip" placeholder="ZIP Code" type="text"/></div>
                  </div>
                </section>
              </div>
            </div>
            <div class="container-fluid p-0">
              <button type="button" class="float-right btn btn-primary" (click)="submit()" *ngIf="!saving">Continue</button>
              <button type="button" class="float-right btn btn-primary pc2-wait" disabled *ngIf="saving">Continue</button>
            </div>
          </div>
          <div class="bordered-content clearfix animated slideInRight faster" style="min-height: 200px" [hidden]="step!==1">
            <label class="label-lg" [hidden]="displaySomeoneElseThanks">Who in your office should we work with:</label>
            <div class="mt-4 align-middle" [hidden]="displaySomeoneElseThanks">
              <button class="btn btn-bordered mr-2" [ngClass]="{'btn-outline-primary':sendToSomeoneElse,'btn-primary':!sendToSomeoneElse}" type="button" (click)="selectContactPerson(!1)">Me</button>
              <button class="btn btn-bordered" [ngClass]="{'btn-outline-primary':!sendToSomeoneElse,'btn-primary':sendToSomeoneElse}" type="button" (click)="selectContactPerson(!!1)">Someone Else</button>
            </div>
            <div class="mt-3" *ngIf="sendToSomeoneElse && !displaySomeoneElseThanks">
              <div class="mb-3">Please provide their info:</div>
              <div class="row pc2-form-group">
                <div class="col-6"><input class="form-control" [(ngModel)]="otherContact.fname" placeholder="First Name" type="text"/></div>
                <div class="col-6"><input class="form-control" [(ngModel)]="otherContact.lname" placeholder="Last Name" type="text"/></div>
              </div>
              <div class="row pc2-form-group">
                <div class="col-sm-6">
                  <input class="form-control" [(ngModel)]="otherContact.email" placeholder="Email" type="email"/>
                </div>
                <div class="col-sm-6">
                  <input class="form-control" [(ngModel)]="otherContact.phone" placeholder="Phone" type="text"/>
                </div>
              </div>
              <div class="mt-3">
                <button type="button" class="float-right btn btn-primary" (click)="addNewContact()" *ngIf="!saving">Continue</button>
                <button type="button" class="float-right btn btn-primary pc2-wait" disabled *ngIf="saving">Continue</button>
              </div>
            </div>
            <div class="mt-4" *ngIf="sendToSomeoneElse && displaySomeoneElseThanks">
              <p>Thank You.</p>
              <p>We are sending a link to {{otherContact.fname}} {{otherContact.lname}} to answer a few questions to optimize your account.</p>
            </div>
          </div>
          <div class="bordered-content clearfix animated slideInRight faster" style="min-height: 200px" [hidden]="step!==2">
            <label class="label-lg">Please select your practice’s primary medical supply:</label>
            <div class="mt-4" *ngIf="distributorsList.length">
              <select [ngModel]="distr_id" (change)="distr_id = $event.target?.value" class="form-control" [ngModelOptions]="{standalone: true}">
                <option value="0" disabled>Please select</option>
                <option *ngFor="let dist of distributorsList | orderBy:'survey_order'" value="{{dist.id}}">{{dist.name}}</option>
              </select>
            </div>
            <div class="mt-4 align-middle">
              <button class="btn btn-lg btn-bordered btn-primary" type="button" (click)="nextStepUI()">Next &nbsp;<i class="fas fa-angle-right"></i></button>
              <button class="ml-2 btn btn-sm btn-bordered btn-outline-secondary" type="button" (click)="nextStepUI(!!1)">Skip</button>
            </div>
          </div>
          <div class="bordered-content clearfix animated slideInRight faster" style="min-height: 200px" [hidden]="step!==3">
            <label class="label-lg">Does your practice also use any of the distributors below?</label>
            <div class="mt-4" *ngIf="distributorsList.length">
              <select [ngModel]="secondary_distr_id" (change)="secondary_distr_id = $event.target?.value" class="form-control" [ngModelOptions]="{standalone: true}">
                <option value="0" disabled>Please select</option>
                <option *ngFor="let dist of distributorsSecondaryList | orderBy:'survey_order_secondary'" value="{{dist.id}}">{{dist.name}}</option>
              </select>
            </div>
            <div class="mt-4 align-middle">
              <button class="btn btn-lg btn-bordered btn-primary" type="button" (click)="nextStepUI()">Next &nbsp;<i class="fas fa-angle-right"></i></button>
              <button class="ml-2 btn btn-sm btn-bordered btn-outline-secondary" type="button" (click)="nextStepUI(!!1)">Skip</button>
            </div>
          </div>
          <div class="bordered-content clearfix animated slideInRight faster" style="min-height: 200px" [hidden]="step!==4">
            <label class="label-lg">Please provide your primary distributor rep name below:</label>
            <div class="mt-4">
              <input class="form-control single-border-input" placeholder="Please enter your response" [(ngModel)]="repName"/>
            </div>
            <div class="mt-4 align-middle">
              <button class="btn btn-lg btn-bordered btn-primary" type="button" (click)="nextStepUI()">Next &nbsp;<i class="fas fa-angle-right"></i></button>
              <button class="ml-2 btn btn-sm btn-bordered btn-outline-secondary" type="button" (click)="nextStepUI(!!1)">Skip</button>
            </div>
          </div>
        </section>
      </div>
      <div class="row" [hidden]="loading || step<1 || sendToSomeoneElse">
        <div class="col-10 d-flex align-items-center">
          <circle-progress [percent]="getProgressPercent()" size="36"></circle-progress>
        </div>
        <div class="col-2 d-flex justify-content-end">
          <button class="btn btn-outline-secondary" [disabled]="step<1" (click)="prevStep()"><i class="fas fa-angle-left"></i></button>
          <button class="btn btn-outline-secondary ml-2" [disabled]="isNextStepDisabled()" (click)="nextStepUI()"><i class="fas fa-angle-right"></i></button>
        </div>
      </div>
    </div>
    <div class="col-sm-10 offset-sm-1 mw-100" *ngIf="displayThanks && !displayUsedLink">
      <div class="bordered-container">
        <div class="bordered-content clearfix" style="min-height: 200px">
          <div class="text-center"><h4 class="color-primary">Signup Successful!</h4></div>
          <div class="mt-3 text-nowrap">
            Thank you for signing up for {{themeName}}.<br/>
            Our client managers will review your information and reach out to you with any additional questions to optimize your savings.<br/>
            If you have any questions, please email us at <a href="mailto:{{themeEmail}}">{{themeEmail}}</a> or call us at {{themePhone}}.
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-10 offset-sm-1 mw-100" *ngIf="displayUsedLink">
      <div class="bordered-container">
        <div class="bordered-content clearfix" style="min-height: 200px">
          <div class="p-4">
            We already have this email address associated with a member.<br/>
            Please email us at <a href="mailto:{{themeEmail}}">{{themeEmail}}</a> or call us at {{themePhone}} for further assistance.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
